import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { RuntimeCreatePage } from '@/features/admin/runtimes/runtime-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouveau runtime (porting README #40). */
export const Route = createFileRoute('/$tenant/runtimes/new')({ component: NewRuntimeRoute });

function NewRuntimeRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="runtimes"
      crumbs={[{ label: t('nav.items.runtimes') }, { label: t('admin.runtimes.newTitle') }]}
    >
      <RuntimeCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
